import React, { forwardRef, memo } from 'react'

const HeadsetIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="29.4"
      height="29.4"
      viewBox="0 0 42 42"
      fill="none"
      {...props}>
      <path
        d="M36.5306 32.7041V33.9796C36.5306 35.3328 35.9931 36.6305 35.0363 37.5873C34.0794 38.5441 32.7817 39.0817 31.4286 39.0817H22.5"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5307 21.2246H31.4287C30.7521 21.2246 30.1032 21.4933 29.6248 21.9718C29.1464 22.4502 28.8776 23.099 28.8776 23.7756V30.1532C28.8776 30.8297 29.1464 31.4786 29.6248 31.957C30.1032 32.4354 30.7521 32.7042 31.4287 32.7042H36.5307V21.2246ZM36.5307 21.2246C36.5307 19.2146 36.1348 17.2242 35.3656 15.3672C34.5964 13.5102 33.4689 11.8228 32.0476 10.4015C30.6263 8.98021 28.939 7.85277 27.082 7.08357C25.225 6.31436 23.2346 5.91846 21.2246 5.91846C19.2145 5.91846 17.2242 6.31436 15.3672 7.08357C13.5102 7.85277 11.8228 8.98021 10.4015 10.4015C8.98021 11.8228 7.85277 13.5102 7.08357 15.3672C6.31436 17.2242 5.91846 19.2146 5.91846 21.2246M5.91846 21.2246V30.1532C5.91846 30.8297 6.18722 31.4786 6.66563 31.957C7.14404 32.4354 7.7929 32.7042 8.46948 32.7042H11.0205C11.6971 32.7042 12.3459 32.4354 12.8243 31.957C13.3027 31.4786 13.5715 30.8297 13.5715 30.1532V23.7756C13.5715 23.099 13.3027 22.4502 12.8243 21.9718C12.3459 21.4933 11.6971 21.2246 11.0205 21.2246H5.91846Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

HeadsetIcon.displayName = 'HeadsetIcon'

export default memo(HeadsetIcon)
